
function MicroLoader({ classNames, customStyle }) {
    return (
        <div className={`micro-loader ${classNames || ""}`} style={customStyle ? { ...customStyle } : {}}></div>
    )
}

export default MicroLoader